import { Button, Form, Icon, Input, Select } from 'antd';
import React, { Component } from 'react';
import '../SearchForm/SearchForm.css';

const { Option } = Select;

class Search extends Component {
  componentDidMount() {
    if (typeof this.props.onRef === 'function') this.props.onRef(this);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.fn(this.props.form);
  };

  handleReset = () => {
    this.props.form.resetFields();
    this.props.fnReset();
  };

  clearTxtSearch = () => {
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { countryList, gatewayList, placeholder } = this.props;

    return (
      <Form className="search-frm" layout="inline" onSubmit={this.handleSubmit}>
        <Form.Item>
          {getFieldDecorator('gateway_id', {
            rules: [{ required: false }],
          })(
            <Select
              showSearch
              placeholder="Gateway"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: '250px' }}
            >
              {(gatewayList || []).map((item, i) => (
                <Option key={i} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('country_abbr', {
            rules: [{ required: false }],
          })(
            <Select
              showSearch
              placeholder="ประเทศ"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: '200px' }}
            >
              {(countryList || []).map((item, i) => (
                <Option key={i} value={item.region_code}>
                  {item.name}
                </Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('searchTxt', {
            rules: [{ required: false, message: 'กรุณากรอกข้อความ' }],
          })(
            <Input
              prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder={placeholder || 'ค้นหา'}
              style={{ width: '200px' }}
            />,
          )}
        </Form.Item>
        <Form.Item>
          <Button.Group>
            <Button htmlType="submit" icon="search" />
            <Button icon="redo" onClick={this.handleReset} />
          </Button.Group>
        </Form.Item>
      </Form>
    );
  }
}

const SearchForm = Form.create({ name: 'search-frm' })(Search);

export default SearchForm;



// WEBPACK FOOTER //
// ./src/containers/Senders/search-form.js